import type { User } from "./protocol.ts";

export async function request<T>(path: string, body?: unknown): Promise<T> {
  let response: Response;
  try {
    response = await fetch(path, { credentials: "same-origin", method: body === undefined ? "GET" : "POST", headers: body === undefined ? undefined : { "Content-Type": "application/json" }, body: body === undefined ? undefined : JSON.stringify(body), signal: AbortSignal.timeout(15000) });
  } catch { throw new Error("O servidor não respondeu. Confira se está ligado e tente novamente."); }
  const data = await response.json() as { error?: string };
  if (!response.ok) throw new Error(data.error ?? "Não foi possível concluir a operação.");
  return data as T;
}
export const session = (roomKey?: string) => request<{ user: User | null }>(`/api/session${roomKey ? `?room=${encodeURIComponent(roomKey)}` : ""}`);
